import Formation from '../../types/api/Formation';
import { Box, Button, Dialog, Stack } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { deleteFormations, listFormations, upsertFormation } from '../../api/restaurant';
import { useEffect, useState } from 'react';
import FormationForm from '../../forms/FormationForm';
import YesNoPopup from '../Popups/YesNoPopup';
import AddIcon from '@mui/icons-material/Add';

interface formationsManagementProps {

}

enum FormationFormType {
	add = 'add',
	edit = 'edit'
}

export function FormationsManagement(formationsManagementProps: formationsManagementProps) {

	const [formations, setFormations] = useState<Formation[]>([]);

	// Ajout / édition de formations
	const [employeeFormMode, setEmployeeFormMode] = useState(FormationFormType.add);
	const [formationsForm, setFormationsForm] = useState(false);
	const [formationFormValue, setFormationFormValues] = useState<Formation>({} as Formation);

	// Suppression de formations
	const [toDeleteFormations, setToDeleteFormations] = useState<number[]>([]);
	const [removeFormationPopup, setRemoveFormationPopup] = useState(false);

	const openFormationEditionForm = (formation: Formation) => {
		setFormationFormValues(formation);
		setEmployeeFormMode(FormationFormType.edit);
		setFormationsForm(true);
	}

	const openCreateFormationForm = () => {
		setFormationFormValues({
			id: -1,
			color: '#000000',
			label: '',
			ratio: 0,
			groupingId: undefined,
			groupingPriority: undefined
		} as Formation);
		setEmployeeFormMode(FormationFormType.add);
		setFormationsForm(true);
	};

	const openDeleteFormationConfirmation = (id: number) => {
		setRemoveFormationPopup(true);
		setToDeleteFormations([id]);
	};

	const columns = [
		{
			field: 'id',
			headerName: 'Id',
			width: 80,
			renderCell: (params: any) => {
				return (
					<Box sx={{ color: "secondary.contrastText" }}>
						{params.value}
					</Box>
				)
			}
		},
		{
			field: 'label',
			headerName: 'Nom de la formation',
			flex: 1,
			minWidth: 200,
			renderCell: (params: any) => {
				return (
					<Box sx={{ color: "secondary.contrastText" }}>
						{params.value}
					</Box>
				)
			}
		},
		{
			field: 'color',
			headerName: 'Couleur',
			width: 120,
			renderCell: (params: any) => {
				return (
					<Box sx={{ color: "secondary.contrastText" }}>
						{params.value}
					</Box>
				)
			}
		},
		{
			field: 'groupingId',
			headerName: 'Grouping ID',
			width: 120,
			renderCell: (params: any) => {
				return (
					<Box sx={{ color: "secondary.contrastText" }}>
						{params.value || '-'}
					</Box>
				)
			}
		},
		{
			field: 'groupingPriority',
			headerName: 'Grouping Priority',
			width: 150,
			renderCell: (params: any) => {
				return (
					<Box sx={{ color: "secondary.contrastText" }}>
						{params.value || '-'}
					</Box>
				)
			}
		},
		{
			field: 'actions',
			headerName: 'Actions',
			width: 280,
			sortable: false,
			renderCell: (params: any) => {
				return (
					<Box>
						<Stack direction="row" spacing={1}>
							<Button
								onClick={()=>{openFormationEditionForm(params.row)}}
								variant="contained"
								startIcon={<EditIcon />}
							>
								Éditer
							</Button>
							<Button
								onClick={()=>{openDeleteFormationConfirmation(params.row.id)}}
								variant="contained"
								startIcon={<DeleteIcon />}
								color='error'
							>
								Supprimer
							</Button>
						</Stack>
					</Box>
					
				)
			}
		},
	];

	const deleteSelectedFormations = async () => {
		const res = await deleteFormations(toDeleteFormations);
		if(res && res.data){
			setToDeleteFormations([])
			setRemoveFormationPopup(false)
			updateFormations();
		}
	}

	const updateFormations = async () => {
		const res = await listFormations();
		if (res && res.code === 200 && res.data) {
			setFormations(res.data);
			console.log(res.data);
		}
	};

	const saveFormation = async (Formation: Formation) => {
		const res = await upsertFormation(Formation);
		if (res && res.data) {
			setFormationsForm(false);
			updateFormations();
		}
	};

	useEffect(() => {
		updateFormations();
	}, []);
	

	return (
		<>
			<Stack direction="row" spacing={2} alignItems="center" justifyContent="space-between" sx={{paddingY: 2}}>
				<Box></Box>
				<Button
					color='success'
					variant="contained"
					onClick={openCreateFormationForm}
					startIcon={<AddIcon />}
				>
					Créer
				</Button>
			</Stack>

			<DataGrid
				rows={formations}
				sx={{ color: "primary.main" }}
				columns={columns}
				disableColumnMenu
				disableColumnSorting
				disableRowSelectionOnClick
				getRowId={(row) => row.id}
				initialState={{
					pagination: {
						paginationModel: { pageSize: 10, page: 0 },
					},
				}}
				localeText={{
					noRowsLabel: 'Aucune formation créée',
					MuiTablePagination: {
						labelRowsPerPage: 'Lignes par page :'
					}
				}}
				pageSizeOptions={[10, 25, 50]}
			/>

			<FormationForm
				open={formationsForm}
				confirmLabel={
					employeeFormMode === FormationFormType.add ? 'Créer' : employeeFormMode === FormationFormType.edit ? 'Modifier' : 'Error'
				}
				save={saveFormation}
				baseFormation={formationFormValue}
				updateFormation={setFormationFormValues}
				close={() => {
					setFormationsForm(false);
				}}
			/>

			<Dialog open={removeFormationPopup}>
				<YesNoPopup
					message="Voulez-vous vraiment supprimer ce(s) formations ?"
					no={() => {
						setRemoveFormationPopup(false);
					}}
					yes={deleteSelectedFormations}
				/>
			</Dialog>
		</>
	);
}

export default FormationsManagement;